// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { callPrivateApi } from '@/api/apiHelper'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { initGetEventResp, initUpdateEventReq } from '@/api/adapter'
import { DMControllerUpdatePayload } from '@/enitites/display-mode/model/types'
import {
  IEvent,
  IEventCarpet,
  IEventFeedbackPostData,
  IEventPeriodStats,
  IEventPreview,
  IEventSearchParams,
  IEventStaff,
  IEventStaffRole,
} from '../model/types'

export const eventApi = {
  async getEvent(eventId: number): Promise<IEvent> {
    const data = await callPrivateApi<IEvent>('get', `/events/${eventId}`)
    return initGetEventResp(data)
  },

  async checkinCurrentUser(eventId: number): Promise<IEvent> {
    const data = await callPrivateApi<IEvent>('post', `/events/${eventId}/checkin`)
    return initGetEventResp(data)
  },

  async getEvents({
    end,
    keyword: k,
    orgIds: o,
    pageNumber: p,
    pageSize: pp,
    sortBy: s,
    start,
    tab: t,
    userId: u,
    userLat: ulat,
    userLng: ulon,
  }: IEventSearchParams): Promise<IEventPreview[] | string> {
    const data = await callPrivateApi('get', '/events', {
      params: {
        p,
        pp,
        t,
        s,
        u,
        k,
        o,
        ulat,
        ulon,
        start,
        end,
      },
    })
    if (!Array.isArray(data)) return data
    return data.map((event) => initGetEventResp(event))
  },
  async getEventsAvailableTabs({ userId, orgId }: { userId?: number; orgId?: number }): Promise<IEventPeriodStats> {
    return callPrivateApi('get', '/events/tabs', { params: { u: userId, o: orgId } })
  },
  async addEvent(): Promise<IEvent> {
    const data = await callPrivateApi('post', '/events')
    return initGetEventResp(data)
  },
  async updateEvent(event: IEvent): Promise<IEvent> {
    const data = await callPrivateApi('post', `/events/${event.id}`, initUpdateEventReq(event))
    return initGetEventResp(data)
  },

  async addRole(eventId: number, userId: number, role: IEventStaffRole): Promise<IEventStaff> {
    return callPrivateApi('post', `/events/${eventId}/role`, { userId, role })
  },

  async removeRole(eventId: number, userId: number, role: IEventStaffRole): Promise<IEventStaff> {
    return callPrivateApi('delete', `/events/${eventId}/role`, { data: { userId, role } })
  },
  async publishEvent(eventId: number) {
    return callPrivateApi('post', `/events/${eventId}/publish`)
  },
  async deleteEvent(eventId: number) {
    return callPrivateApi('post', `/events/${eventId}/delete`)
  },
  async checkInUser(eventId: number, userId: number): Promise<IEvent> {
    const data = await callPrivateApi('post', `/events/${eventId}/checkin/${userId}`)
    return initGetEventResp(data)
  },
  async toggleLike(eventId: number): Promise<boolean> {
    return callPrivateApi('post', `/events/${eventId}/like`)
  },
  async postFeedback(eventId: number, feedback: IEventFeedbackPostData): Promise<string> {
    const data = await callPrivateApi('post', `/events/${eventId}/feedback`, feedback)
    return initGetEventResp(data)
  },
  async updateEventCarpets(eventId: number, carpets: { id: number; name: string }[]): Promise<IEventCarpet[]> {
    return callPrivateApi('post', `/events/${eventId}/carpets`, carpets)
  },
  async initEventScoreboards(eventId: number) {
    return callPrivateApi('post', `/events/${eventId}/scoreboards/init`)
  },
  async updateEventScoreboard(
    eventId: number | string,
    carpetId: number,
    scoreboardPayload: DMControllerUpdatePayload
  ) {
    return callPrivateApi('put', `/events/${eventId}/scoreboards/carpet/${carpetId}`, scoreboardPayload)
  },
}
